import React from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles } from "@material-ui/styles";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ToggleButtonGroup,
  ToggleButton,
} from "@material-ui/core";
import configData from "../../../../config";
import axios from "axios";


// style const
const useStyles = makeStyles((theme) => ({
  navContainer: {
    width: "100%",
    maxWidth: "350px",
    minWidth: "200px",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "10px",
    [theme.breakpoints.down("sm")]: {
      minWidth: "100%",
    },
  },
  headerAvatar: {
    cursor: "pointer",
    ...theme.typography.mediumAvatar,
    margin: "8px 0 8px 2px !important",
  },
  profileChip: {
    // flexGrow: 1,
    height: "40px",
    alignItems: "center",
    borderRadius: "25px",
    transition: "all .2s ease-in-out",
    borderColor: theme.palette.primary.light,
    backgroundColor: theme.palette.secondary.main,
    '&[aria-controls="menu-list-grow"], &:hover': {
      borderColor: theme.palette.primary.main,
      background: theme.palette.primary.main + "!important",
      color: theme.palette.primary.light,
      "& svg": {
        stroke: theme.palette.primary.light,
      },
    },
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  profileLabel: {
    lineHeight: 1.2,
    padding: "10px",
  },
  listItem: {
    marginTop: "5px",
  },
  cardContent: {
    padding: "16px !important",
  },
  card: {
    backgroundColor: theme.palette.primary.light,
    marginBottom: "16px",
    marginTop: "16px",
  },
  searchControl: {
    width: "100%",
    paddingRight: "8px",
    paddingLeft: "16px",
    marginBottom: "16px",
    marginTop: "16px",
  },
  startAdornment: {
    fontSize: "1rem",
    color: theme.palette.grey[500],
  },
  flex: {
    display: "flex",
  },
  name: {
    marginLeft: "2px",
    fontWeight: 400,
  },
  ScrollHeight: {
    height: "100%",
    maxHeight: "calc(100vh - 250px)",
    overflowX: "hidden",
  },
  badgeWarning: {
    backgroundColor: theme.palette.warning.dark,
    color: "#fff",
  },
  tableWithBorders: {
    borderCollapse: "collapse",
    width: "100%",
    "& th, & td": {
      border: "1px solid #ccc",
    },
  },
  customTypography: {
    [theme.breakpoints.down("lg")]: {
      fontSize: "9px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "9px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "9px",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "9px",
    },
    [theme.breakpoints.between("xs", "sm")]: {
      fontSize: "8px",
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: "8px",
    },
    [theme.breakpoints.between("md", "lg")]: {
      fontSize: "8px",
    },
  },
  modalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    backgroundColor: theme.palette.background.paper,
    borderRadius: "10px",
    boxShadow: 24,
    padding: theme.spacing(3),
    outline: "none",
  },
}));

const ProfileDetails = ({ open, onClose }) => {
  const classes = useStyles();
  const account = useSelector((state) => state.account);
  const [credits, setCredits] = React.useState(100);
  const [mail, setMail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [whatsapp, setWhatsapp] = React.useState("");
  const [renewal, setRenewal] = React.useState("");

  //Profile Starts Here
  const [meterData, setMeterData] = React.useState({});
  const [expanded, setExpanded] = useState(null);

  const handleAccordionChange = (panel) => (e, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  const renderTable = (rows = [], columns = []) => (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell
            style={{ fontSize: "1rem", fontWeight: "600", color: "#545454" }}
          >
            Sr.No
          </TableCell>
          {columns.map((col, idx) => (
            <TableCell
              key={`${col}-${idx}`}
              style={{ fontSize: "1rem", fontWeight: "600", color: "#545454" }}
            >
              {col}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, i) => (
          <TableRow key={`row-${i}`}>
            <TableCell
              style={{ fontSize: "1rem", fontWeight: "600", color: "#545454" }}
            >
              {i + 1}
            </TableCell>
            {columns.map((col, idx) => (
              <TableCell
                key={`${col}-${i}`}
                style={{
                  fontSize: "1rem",
                  fontWeight: "600",
                  color: "#545454",
                }}
              >
                {row[col.toLowerCase().replace(/\s/g, "_")] || "-"}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );

  React.useEffect(() => {
    const fetchAccessData = async () => {
      try {
        const token = account.token;
        const response = await axios.get(
          configData.API_SERVER + "user/profile",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setCredits(response.data.credit || 0);
        setMail(response.data.client_email || "");
        setPhone(response.data.contact_no || "");
        setWhatsapp(
          Array.isArray(response.data.whatsapp_number) &&
            response.data.whatsapp_number.length > 0
            ? response.data.whatsapp_number[0].number
            : "N/A"
        );
        setRenewal(response.data.renewal_date || "");
        setMeterData(response.data || {});
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchAccessData();
  }, [account.token]);

  const renderStandardTable = (data = []) =>
    renderTable(data, ["Meter Name", "Shift Time"]);

  const MeterGroupAccordion = ({ id, title, tabs }) => {
    const [selected, setSelected] = useState(tabs[0]?.label);
    const totalCount = tabs.reduce(
      (sum, tab) => sum + (meterData[tab.key]?.length || 0),
      0
    );

    // Group IDs where toggle buttons should be hidden
    const skipButtonGroups = [
      "ems",
      "bms",
      "trans",
      "vib",
      "steam",
      "nbs",
      "air",
      "agr",
      "gas",
      "solar",
      "flms",
    ];

    const showToggleButtons = !skipButtonGroups.includes(id);

    return (
      <Accordion
        expanded={expanded === id}
        onChange={handleAccordionChange(id)}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <b>
            {title} -{" "}
            <span style={{ color: totalCount === 0 ? "#f22c3d" : "#351e99" }}>
              {totalCount} Meters
            </span>
          </b>
        </AccordionSummary>
        <AccordionDetails>
          {showToggleButtons ? (
            <>
              <ToggleButtonGroup
                value={selected}
                exclusive
                onChange={(e, val) => setSelected(val)}
              >
                {tabs.map((tab) => (
                  <ToggleButton key={`${id}-${tab.label}`} value={tab.label}>
                    {tab.label}
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
              {tabs.map(
                (tab) =>
                  selected === tab.label &&
                  (tab.columns
                    ? renderTable(meterData[tab.key], tab.columns)
                    : renderStandardTable(meterData[tab.key]))
              )}
            </>
          ) : (
            // Directly render all tabs (no toggle buttons)
            tabs.map((tab) =>
              tab.columns
                ? renderTable(meterData[tab.key], tab.columns)
                : renderStandardTable(meterData[tab.key])
            )
          )}
        </AccordionDetails>
      </Accordion>
    );
  };

  const groups = [
    {
      id: "ems",
      title: "Ems",
      tabs: [{ label: "Energy Meters", key: "ems_meters" }],
    },
    {
      id: "water",
      title: "Water",
      tabs: [
        { label: "Water Meters", key: "wms_meters" },
        { label: "Water Controller", key: "water_controller" },
      ],
    },
    {
      id: "dg",
      title: "DG",
      tabs: [
        { label: "DG Meters", key: "dg_meters" },
        { label: "DG Controller", key: "dg_controller" },
      ],
    },
    {
      id: "trans",
      title: "Transformer",
      tabs: [{ label: "Transformer Meters", key: "trans_meters" }],
    },
    {
      id: "bms",
      title: "UPS",
      tabs: [{ label: "Battery Meters", key: "bms_meters" }],
    },
    {
      id: "aqi",
      title: "Air Quality",
      tabs: [
        {
          label: "Temp Sensors",
          key: "temp_meters",
          columns: ["Sensor Name", "Location Name", "Meter ID", "Shift Time"],
        },
        { label: "Indoor Sensors", key: "indoor_aqi_sensors" },
        { label: "Outdoor Sensors", key: "outdoor_aqi_sensors" },
        { label: "Hooter Sensors", key: "hooter_meters" },
      ],
    },
    {
      id: "hvac",
      title: "HVAC",
      tabs: [
        { label: "Chiller Meters", key: "chiller_meters" },
        { label: "Dex Meters", key: "dex_meters" },
        { label: "AHU Meters", key: "ahu_meters" },
        { label: "Cooling Tower Meters", key: "cooling_meters" },
        { label: "Pump Meters", key: "pumps_meters" },
      ],
    },
    {
      id: "vib",
      title: "Vibration",
      tabs: [{ label: "Vibration Sensors", key: "vib_meters" }],
    },
    {
      id: "fms",
      title: "Fire System",
      tabs: [
        { label: "Fire Meters", key: "fms_meters" },
        { label: "Pressure Sensor", key: "fms_pressure_sensors" },
      ],
    },
    {
      id: "steam",
      title: "Steam Sensor",
      tabs: [{ label: "Steam Sensors", key: "steam_sensors" }],
    },
    {
      id: "nbs",
      title: "NBSafe",
      tabs: [{ label: "NBSafe", key: "nbs_meter" }],
    },
    {
      id: "agr",
      title: "Agriculture",
      tabs: [{ label: "Agriculture", key: "agr_meter" }],
    },
    {
      id: "gas",
      title: "Gas",
      tabs: [{ label: "Gas Sensors", key: "gas_sensors" }],
    },
    {
      id: "air",
      title: "Air Sensor",
      tabs: [{ label: "Air Sensors", key: "air_sensors" }],
    },
    {
      id: "flms",
      title: "Flms",
      tabs: [{ label: "Fleet Management", key: "fleet_sensors" }],
    },
    {
      id: "solar",
      title: "Solar Sensor",
      tabs: [{ label: "Solar Sensors", key: "solar_sensors" }],
    },
    // {
    //   id: "environment",
    //   title: "Environment",
    //   tabs: [
    //     { label: "Gas Sensors", key: "gas_sensors" },
    //     { label: "Air Sensors", key: "air_sensors" },
    //     { label: "NBS Meters", key: "nbs_meter" },
    //     { label: "Agri Sensors", key: "dex_meters" },
    //   ],
    // },
  ];

  return (
    <React.Fragment>
      <Dialog open={open} onClose={onClose} maxWidth="md">
        <DialogTitle
          style={{ fontSize: "1.2rem", fontWeight: "600", color: "#351e99" }}
        >
          Profile Details
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Table className={classes.tableWithBorders}>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#212121",
                    backgroundColor: "#f7f6fe",
                  }}
                >
                  User Name
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#212121",
                    backgroundColor: "#f7f6fe",
                  }}
                >
                  Client Email
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#212121",
                    backgroundColor: "#f7f6fe",
                  }}
                >
                  Phone No
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#212121",
                    backgroundColor: "#f7f6fe",
                  }}
                >
                  Whatsapp No
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#212121",
                    backgroundColor: "#f7f6fe",
                  }}
                >
                  Renewal Date
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#212121",
                    backgroundColor: "#f7f6fe",
                  }}
                >
                  Credits
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#545454",
                  }}
                >
                  {account?.user?.name || "-"}
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#545454",
                  }}
                >
                  {mail}
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#545454",
                  }}
                >
                  {phone}
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#545454",
                  }}
                >
                  {whatsapp}
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#545454",
                  }}
                >
                  {renewal}
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                  }}
                >
                  <span
                    style={{
                      color:
                        credits <= 20
                          ? "red"
                          : credits <= 60
                          ? "orange"
                          : "green",
                    }}
                  >
                    {credits}
                  </span>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <div style={{ margin: "30px 0 10px 0" }}>
            <h2
              style={{
                fontSize: "1.3rem",
                fontWeight: "700",
                color: "#351e99",
              }}
            >
              All Meter & Sensor Info
            </h2>
          </div>

          {groups.map((group) => (
            <MeterGroupAccordion key={group.id} {...group} />
          ))}
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handlePassword} color="primary">
            Change Password
          </Button> */}
          <Button onClick={onClose} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ProfileDetails;
